import module from 'nominas/finiquito/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const conceptoBase = {
  id_concepto: null,
  id_naturaleza: null,
  dias: null,
  exento: null,
  gravado: null,
  horas: null,
  importe: null,
  impuesto_estatal: null,
}

export class NominasFiniquitoEscenarioConceptosAgregarComponent {
  idNaturaleza
  conceptos
  onClose
  seleccionados = []

  $onInit () {
    let conceptos = this.conceptos.map((concepto) => {
      return {
        id_concepto: Number(concepto.id),
        descripcion: concepto.concepto,
        id_naturaleza: concepto.naturaleza,
        seleccionado: false,
      }
    })

    this.conceptos = orderBy(conceptos, ['descripcion'])
  }

  agregar (item) {
    if (item.seleccionado) return

    item.seleccionado = true
    this.seleccionados.push(item)
  }

  cerrar () {
    let seleccionados = this.seleccionados
      .map((concepto) => Object.assign({}, conceptoBase, {id_concepto: concepto.id_concepto, id_naturaleza: concepto.id_naturaleza}))

    this.onClose({$event: {detail: seleccionados}})
  }

  seleccionar (item) {
    this.agregar(item)
    this.cerrar()
  }
}

module.component('nominasFiniquitoEscenarioConceptosAgregar', {
  controller: NominasFiniquitoEscenarioConceptosAgregarComponent,
  template,
  bindings: {
    idNaturaleza: '<',
    conceptos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/conceptos/agregar/component.js